import React from 'react';
import { Modal, Box } from '@material-ui/core';
import { AddCertificates } from './index';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  padding: 20,
  overflowY: 'scroll',
  height: '90%',
};

const UpdateCertificate = ({ certificateDetails, openModal, setOpenModal, ...rest }) => {
  const handleClose = () => setOpenModal(false);
  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <AddCertificates {...{
            certificateDetails,
            addCertificate: false,
            handleClose,
            ...rest
          }} />
        </Box>
      </Modal>
    </div>
  )
}

export default UpdateCertificate;
